var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import MPSessionStorage from "@/services/MPSessionStorage";
/**
 * The five campaign parameters authx360 accepts on /login and the backend accepts in the
 * register_partner body. Nothing else is forwarded: PASSED_QUERY holds the WHOLE query
 * string that was on the URL at first load (leadct_id, account_manager, and anything else
 * a campaign appended), and spreading that wholesale would leak unrelated parameters into
 * an auth redirect.
 */
var UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
];
/**
 * The prefixed keys, as authx360 expects them on the /login query string.
 *
 * The source is the snapshot ViewsContainer writes to sessionStorage on first load (as soon
 * as any utm_* is present), NOT window.location.search: by the time the user reaches the
 * signup form or a login redirect, the campaign parameters are several navigations behind.
 */
export var getUtmParams = function () {
    var saved;
    try {
        saved = JSON.parse(MPSessionStorage.get(MPSessionStorage.keys.PASSED_QUERY) || "{}");
    }
    catch (_a) {
        // A hand-edited or truncated sessionStorage value must not break a login redirect.
        return {};
    }
    return UTM_KEYS.reduce(function (params, key) {
        var value = saved === null || saved === void 0 ? void 0 : saved[key];
        // Empty strings are dropped too: "utm_source=" carries no campaign and would only
        // make the property non-null-but-useless in the reports this feeds.
        if (typeof value === "string" && value)
            params[key] = value;
        return params;
    }, {});
};
/**
 * The prefixed parameters as a fragment ready to append to an existing query string, each
 * value encoded so a campaign name containing & or a space cannot break the URL. Returns
 * "" when nothing was captured, so the caller appends nothing.
 *
 * Lives here rather than in authHub because authHub pulls in axios, which this repo's
 * jest cannot load -- keeping it here keeps it under test.
 */
export var getUtmQueryString = function () {
    return Object.entries(getUtmParams())
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return "&".concat(key, "=").concat(encodeURIComponent(value));
    })
        .join("");
};
/**
 * The same values in the nested, unprefixed shape the register_partner body expects:
 * { utm: { source, medium, campaign, term, content } }.
 *
 * Returns undefined when nothing was captured, so the caller can omit the key entirely
 * rather than posting an empty object.
 */
export var getUtmPayload = function () {
    var params = getUtmParams();
    var payload = {
        source: params.utm_source,
        medium: params.utm_medium,
        campaign: params.utm_campaign,
        term: params.utm_term,
        content: params.utm_content
    };
    var populated = Object.entries(payload).filter(function (_a) {
        var _b = __read(_a, 2), value = _b[1];
        return value;
    });
    return populated.length ? Object.fromEntries(populated) : undefined;
};
//# sourceMappingURL=data:application/json;base64,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